module.exports = __webpack_public_path__ + "img/leumi.56dcf165.jpg";